import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import './index.css';
import './styles/breakpoints.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';

// PostHog analytics (traffic and events) – only when REACT_APP_POSTHOG_KEY is set
if (typeof window !== 'undefined' && process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: 'https://us.i.posthog.com',
  });
}

// Force-unregister any existing service workers in production to avoid stale assets.
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  }).catch((err) => {
    console.warn('Service worker unregister failed:', err);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// Debug: Check if Dialog Portal container exists
setTimeout(() => {
  const portals = document.querySelectorAll('[data-radix-portal]');
  console.log('Radix Portals found:', portals.length);
  portals.forEach((p, i) => {
    console.log(`Portal ${i}:`, p);
  });
}, 2000);

